import { render, staticRenderFns } from "./CampoFechaFirma.vue?vue&type=template&id=346820bb"
import script from "./CampoFechaFirma.vue?vue&type=script&lang=js"
export * from "./CampoFechaFirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports